import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/integratedPropertySolutions.css';

const IntegratedPropertySolutionsSection = ({ layout = 'full', ctaOverride = null }) => {
  
  // Compact layout for Homepage
  if (layout === 'compact') {
    return (
      <section className="integrated-solutions-compact">
        <div className="section-inner">
          <div className="compact-wrapper">
            <div className="compact-image">
              <img src="/images/landscape/landscapeAll2A.jpg" alt="Modern sustainable commercial landscape" />
            </div>
            <div className="compact-content">
              <h3>MAINTENANCE SOLUTIONS</h3>
              <h2>One Call Handles Everything Outside</h2>
              <p className="lead-text">
               All Seasons delivers complete care for your property in every season. From custom landscapes to round-the-clock snow and ice management, we simplify outdoor living so you can focus on what matters most.
              </p>
              <div className="service-highlights">
                <h4>Complete coverage includes:</h4>
                <ul>
                  <li>Comprehensive irrigation installation & maintenance</li>
                  <li>Weekly property walks for proactive oversight</li>
                  <li>Snow & ice management — from rooftops to walkways</li>
                  <li>Seasonal upkeep tailored to mountain living</li>
                  <li>24/7 emergency response for snow and ice hazards</li>
                  {/* <li>Complete irrigation system design and maintenance</li>
                  <li>Storm damage cleanup and mitigation</li> */}
                </ul>
              </div>
              <p className="bottom-line-text">
                <strong>We handle the details. You enjoy the seasons.</strong>
              </p>
              {ctaOverride ? (
                <a
                  href={ctaOverride.link}
                  className="btn-cta"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {ctaOverride.text}
                </a>
              ) : (
                <Link to="/Maintenance" className="btn-cta">
                  Our Maintenance Solutions
                </Link>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Full layout for Property Management Page
  return (
    <section className="integrated-solutions-full">
      <div className="section-inner">
        <h2 className="section-title text-center">THE ALL SEASONS ADVANTAGE</h2>
        <p className="section-subtitle text-center">
          Complete outdoor management from one trusted partner
        </p>
        
        <div className="hero-feature">
          <div className="hero-image">
            <img src="/images/prairie-commercial-landscape.jpg" alt="Beautiful low-maintenance commercial landscape" />
            <div className="image-caption">
              Modern landscape design at Riverside Office Park - 
              drought-tolerant plantings, fire-safe spacing, integrated drainage solutions
            </div>
          </div>
        </div>

        <div className="integrated-approach">
          <div className="approach-card" data-number="01">
            <div className="approach-image">
              <img src="/images/maintenance/flowersYard.JPG" alt="Smart landscape design" />
            </div>
            <h4>Complete coverage includes:</h4>
            <ul>
              <li>Comprehensive irrigation installation & maintenance</li>
                  <li>Weekly property walks for proactive oversight</li>
                  <li>Snow & ice management — from rooftops to walkways</li>
                  <li>Seasonal upkeep tailored to mountain living</li>
                  <li>24/7 emergency response for snow and ice hazards</li>
            </ul>
            <p className="bottom-text">Long-term savings through intelligent design</p>
          </div>

          <div className="approach-card" data-number="02">
            <div className="approach-image">
              <img src="/images/maintenance/mowingBig1.jpg" alt="Comprehensive maintenance services" />
            </div>
            <h3>COMPREHENSIVE MAINTENANCE & MANAGEMENT</h3>
            <ul>
              <li>Complete irrigation system design, install & maintenance</li>
              <li>Weekly property walks catch issues early</li>
              <li>Snow & ice management - ground to rooftop</li>
              <li>Storm preparation and damage cleanup</li>
              <li>Climate-adapted tree installation and care</li>
            </ul>
            <p className="bottom-text">One contract covers everything outside</p>
          </div>

          <div className="approach-card highlighted" data-number="03">
            <div className="approach-image">
              <img src="/images/snowRemovalAS.png" alt="24/7 emergency response" />
            </div>
            <h3>24/7 EMERGENCY RESPONSE</h3>
            <ul>
              <li>Local crews, fast response times & 24/7 emergency contact line</li>
              <li>Flooding response and water redirect solutions</li>
              <li>River overflow mitigation and management</li>
              <li>Snow removal from rooftops and emergency exits</li>
              <li>Storm damage and fallen tree removal</li>
            </ul>
            <p className="bottom-text">We answer when others won't</p>
          </div>
        </div>

        <div className="complete-services">
          <h3>EVERYTHING OUTSIDE IS OUR RESPONSIBILITY</h3>
          <div className="services-columns">
            <div className="service-column">
              <h4>Design & Installation</h4>
              <ul>
                <li>Landscape design and construction</li>
                <li>Irrigation system design</li>
                <li>Drainage solutions</li>
                <li>Fire-safe landscaping</li>
                <li>Erosion control</li>
              </ul>
            </div>
            <div className="service-column">
              <h4>Maintenance & Care</h4>
              <ul>
                <li>Complete landscape maintenance</li>
                <li>Irrigation management</li>
                <li>Tree and shrub care</li>
                <li>Seasonal color programs</li>
                <li>Property monitoring</li>
              </ul>
            </div>
            <div className="service-column">
              <h4>Emergency Services</h4>
              <ul>
                <li>24/7 response line</li>
                <li>Snow & ice management</li>
                <li>Flood mitigation</li>
                <li>Storm damage cleanup</li>
                <li>Water redirect solutions</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bottom-line">
          <h3>One Call Handles Everything Outside</h3>
          <p>
            While other companies give you a list of what they can't do, we figure out how to get it done. 
            From routine maintenance to emergency response, from sustainable design to snow on the roof - 
            if it's outside your building, it's our responsibility.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntegratedPropertySolutionsSection;